import { PermissionPortalModule } from '@d-models/other/user.model';
import { createAction, props } from '@ngrx/store';

export enum AppConfigActions {
  UPDATE_CURRENCY_CONFIG = 'UPDATE_CURRENCY_CONFIG',
  UPDATE_CURRENT_PERMISSION = '[CONFIG] Update current permission',
}
export const updateCurrencyConfig = createAction(
  AppConfigActions.UPDATE_CURRENCY_CONFIG,
  props<{ currency: string; currencyPrefix: string }>(),
);

export const updateCurrentPermission = createAction(
  AppConfigActions.UPDATE_CURRENT_PERMISSION,
  props<{ modulePermission: PermissionPortalModule[] }>(),
);
